export const values = {
  'oneMillion': 1000000,
  'tenThousand': 10000
}
